<template>
	<div class="index-page">
			<b-modal id="modal-input" scrollable :no-close-on-backdrop="true" :title="'Advance Filter'" :no-close-on-esc="true" v-model="isFilterShow"
			:dialog-class="''"
			:ok-title="'Search'"
			ok-variant="success"
			:cancel-title="'Clear'"
			@ok="getVersionNotifications"
			@hidden="resetModal">
				<b-card class="advance-filter-card">
				<b-row>
					<b-col cols="12" lg="6">
							<app-input-combobox class="advance-filter-field" :options="platformOptions" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Platform" id="filter-platform" size="sm" :model.sync="filter.platform" :selected="getOptionName(platformOptions, filter.platform)" />
							<app-input-textbox class="advance-filter-field" id="fieldset-version" label-cols-sm="4" label-cols-lg="3" label="Version" label-for="filter-version" size="sm" :model.sync="filter.version" />
					</b-col>
					<b-col cols="12" lg="6">
							<app-input-combobox class="advance-filter-field" :options="modeOptions" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Mode" id="filter-mode" size="sm" :model.sync="filter.mode" :selected="getOptionName(modeOptions, filter.mode)" />
							<app-input-textbox class="advance-filter-field" id="fieldset-title-notification" label-cols-sm="4" label-cols-lg="3" label="Title Notification" label-for="filter-title-notification" size="sm" :model.sync="filter.titleNotification" />
							<app-input-textarea class="advance-filter-field" id="fieldset-message-notification" label-cols-sm="4" label-cols-lg="3" label="Message Notification" label-for="filter-message-notification" size="sm" :model.sync="filter.messageNotification" />
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

			<div>
				<b-row class="mb-2 d-flex">
				<b-col class="pt-1">
					<span class="function-title">Version Notification</span>
				</b-col>
				<b-col class="d-sm-none d-md-block">
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm"></b-dropdown>
						<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
							:show="isCreateBusy"
							opacity="0.6"
							spinner-small
							spinner-variant="default"
							class="d-inline">
							<b-button class="btn-create btn-fill-success" to="/versionnotification/create" size="sm"><b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
						</b-overlay>
					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
							<b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
								:show="isCreateBusy"
								opacity="0.6"
								spinner-small
								spinner-variant="default"
								class="d-inline">
								<b-button class="btn-create btn-fill-success" to="/versionnotification/create" size="sm"><b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
							</b-overlay>
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="false" class="btn-action d-sm-none d-md-inline" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-versionnotification" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="versionNotifications" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="versionNotifications.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
						<template #top-row v-if="isShowFilter">
							<b-th></b-th>
							<b-th></b-th>
							<b-th stacked-heading="Platform" class="table-filter">
								<v-select class="table-filter-select" append-to-body label="name" :options="platformFilterOptions" :value="filter.platform" :reduce="item => item.id" v-model="filter.platform" :filterable="false" @input="getVersionNotificationsWithoutLoading"></v-select>
							</b-th>
							<b-th stacked-heading="Version" class="table-filter">
								<b-form-input id="input-version-table" @input="getVersionNotificationsWithoutLoading" v-model="filter.version" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Mode" class="table-filter">
								<v-select class="table-filter-select" append-to-body label="name" :options="modeFilterOptions" :value="filter.mode" :reduce="item => item.id" v-model="filter.mode" :filterable="false" @input="getVersionNotificationsWithoutLoading"></v-select>
							</b-th>
							<b-th stacked-heading="Title Notification" class="table-filter">
								<b-form-input id="input-title-notification-table" @input="getVersionNotificationsWithoutLoading" v-model="filter.titleNotification" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Message Notification" class="table-filter">
								<b-form-input id="input-message-notification-table" @input="getVersionNotificationsWithoutLoading" v-model="filter.messageNotification" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Select All">
								<b-form-checkbox id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
							</b-th>
						</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + (pageSizeOptions * (currentPage - 1))) }}
					</template>
					<template v-slot:cell(platform)="row">
						<a @click="() => ($router.push({ name: 'versionnotificationdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.platform }}
						</a>
					</template>
					<template v-slot:cell(messageNotification)="row">
						<app-long-text :maxLength="60" :text="row.item.messageNotification != null ? row.item.messageNotification : ''" />
					</template>
					<template v-slot:cell(titleNotification)="row">
						<app-long-text :maxLength="50" :text="row.item.titleNotification != null ? row.item.titleNotification : ''" />
					</template>
					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(row.item.id)" :checked="checkAllData.includes(row.item.id)"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-combobox :options="modeOptions" optionsLabel="name" optionsKey="id" label-cols-lg="12" :model="row.item.mode" label="Mode" :selected="row.item.mode" :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-title-notification-detail" label-cols-lg="12" label="Title Notification" label-for="input-title-notification-detail" size="sm" :model.sync="row.item.titleNotification" :isEditable="false" :isUpdatable="true" />
							<app-input-textarea id="fieldset-message-notification-detail" label-cols-lg="12" label="Message Notification" label-for="input-message-notification-detail" size="sm" :model.sync="row.item.messageNotification" :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-store-button-label-detail" label-cols-lg="12" label="Store Button Label" label-for="input-store-button-label-detail" size="sm" :model.sync="row.item.storeButtonLabel" :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-dismiss-button-label-detail" label-cols-lg="12" label="Dismiss Button Label" label-for="input-dismiss-button-label-detail" size="sm" :model.sync="row.item.dismissButtonLabel" :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-close-button-label-detail" label-cols-lg="12" label="Close Button Label" label-for="input-close-button-label-detail" size="sm" :model.sync="row.item.closeButtonLabel" :isEditable="false" :isUpdatable="true" />
						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(versionNotificationsPaging != null ? versionNotificationsPaging.dataCount : 0)"
									:per-page="(versionNotificationsPaging != null ? versionNotificationsPaging.pageSize : 0)"
									aria-controls="table-list-versionnotification">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

	::v-deep #table-list-versionnotification.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
		background-image: url(/img/box-checklist.png);
		background-size: 40px 40px;
		display: block;
		width: 40px;
		height: 40px;
		content: "";
		margin-bottom: 10px;
	}

		::v-deep #table-list-versionnotification.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
			display: flex;
		}

		::v-deep #table-list-versionnotification .table-filter-select .vs__dropdown-toggle {
			min-height: calc(1.5em + .5rem);
		}

		.advance-filter-card ::v-deep fieldset.form-group {
			margin-bottom: 0;
		}

		.advance-filter-field {
			margin-bottom: 1.5rem;
		}

		.advance-filter-card ::v-deep textarea.form-control {
			min-height: 76px;
		}
	</style>
<script>
import VersionNotification from '@/models/VersionNotification/VersionNotification';
import VersionNotificationList from '@/models/VersionNotification/VersionNotificationList';
import VersionNotificationFilter from '@/filters/VersionNotification/VersionNotificationFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppLongText from '@/components/AppLongText';

export default {
	components : {
		AppInputTextbox,
		AppInputTextarea,
		AppInputCombobox,
		AppLongText,
	},
	data() {
		return {
			selectAll: false,
			sortBy: 'id',
			sortDesc: true,
			pagingOptions: [
				{ value : 10, text : '10', selected:true },
				{ value : 25, text : '25' },
				{ value : 50, text : '50' },
				{ value : 100, text : '100' },
			],
			currentPage: 1,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"platform": {}, "class" : "th-platform first-child", "label" : "Platform", key: 'platform', sortable: true},
				{"version": {}, "class" : "th-version", "label" : "Version", key: 'version', sortable: true},
				{"mode": {}, "class" : "th-mode d-stack-none", "label" : "Mode", key: 'mode', sortable: true},
				{"titleNotification": {}, "class" : "th-title-notification d-stack-none", "label" : "Title Notification", key: 'titleNotification', sortable: true},
				{"messageNotification": {}, "class" : "th-message-notification last-child d-stack-none", "label" : "Message Notification", key: 'messageNotification', sortable: true},
				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			isDataLoading: false,
			isDeleteBusy: false,
			isCreateBusy: false,
			pageSizeOptions: 10,
			sortingBy: Array(),
			filter: null,
			versionNotifications: [],
			versionNotificationsPaging: {},
			isFilterShow: false,
			isShowFilter: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			platformOptions: [
				{ id: 'iOS', name: 'iOS' },
				{ id: 'android', name: 'android' },
			],
			modeOptions: [
				{ id: 'Mandatory', name: 'Mandatory' },
				{ id: 'Optional', name: 'Optional' },
				{ id: 'Expired', name: 'Expired' },
			],
		}
	},
	methods : {
		getVersionNotifications : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			VersionNotificationList.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.versionNotifications = result.data;
					this.versionNotificationsPaging = result;
				}
				this.isDataLoading = false;
			})
			.catch(() => {
				this.versionNotifications = [];
				this.versionNotificationsPaging = {};
				this.isDataLoading = false;
			});
		},
		getVersionNotificationsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			VersionNotificationList.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.versionNotifications = result.data;
					this.versionNotificationsPaging = result;
				}
			})
			.catch(() => {});
		},
		resetFilter() {
			this.filter = new VersionNotificationFilter();
			this.currentPage = 1;
			this.getVersionNotifications();
			this.isFilterShow = false;
		},
		resetModal() {
			this.isFilterShow = false;
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		deleteData(id) {
			VersionNotification.deleteData(this, id).then(result => {
				if (result) {
					this.getVersionNotifications();
				}
			});
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				VersionNotification.getHttp(this).post('versionnotification/deletemultidata', { ids: data })
				.then(() => {
					this.$store.dispatch("removeCheckAllData");
					this.getVersionNotifications();
					this.isDeleteBusy = false;
				})
				.catch(() => { this.isDeleteBusy = false; });
			}
		},
		createData() {
			this.$router.push({ name: 'versionnotificationcreate' });
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			}
		},
		scrollRight() {
			var tableVersionNotificationParent = document.getElementById('table-list-versionnotification').parentNode;
			tableVersionNotificationParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableVersionNotificationParent.scrollWidth - tableVersionNotificationParent.offsetWidth) == Math.ceil(tableVersionNotificationParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableVersionNotificationParent = document.getElementById('table-list-versionnotification').parentNode;
			tableVersionNotificationParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableVersionNotificationParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return;
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		},
		getOptionName(options, id) {
			let option = options.find(item => item.id === id);
			return option != null ? option.name : '';
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new VersionNotificationFilter();
	},
	mounted(){
		let breadcrumb = [
			"Master Data",
			"Version Notification"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getVersionNotifications();
			window.addEventListener('resize', this.onResize);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getVersionNotifications();
			}
		},
		sortDesc: {
			handler: function() {
				this.getVersionNotifications();
			}
		},
		currentPage: {
			handler: function() {
				this.getVersionNotifications();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getVersionNotifications();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				VersionNotificationList.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to) {
			if (to != null && to.name == "versionnotificationindex") {
				this.getVersionNotificationsWithoutLoading();
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "version_notification").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}

			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		},
		platformFilterOptions() {
			return [{ id: '', name: 'All' }].concat(this.platformOptions);
		},
		modeFilterOptions() {
			return [{ id: '', name: 'All' }].concat(this.modeOptions);
		},
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
		window.removeEventListener('resize', this.onResize);
	},
}
</script>
